import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';

export default function BillingsGaugeGraphComponent() {
  return (
    <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="subtitle2"
        padding={1}
        textAlign="center"
        fontWeight={600}
        component="div"
      >
        {
          'Our billings Elements have been replaced with Brand New Revenue Elements, to add them choose Edit Dashboard > Add Element > Revenue'
        }
      </Typography>
    </Paper>
  );
}
